// Metric to do with WDM registration
export const METRICS = {
  JS_SDK_CREDENTIALS_DOWNSCOPE_FAILED: 'JS_SDK_CREDENTIALS_DOWNSCOPE_FAILED',
  JS_SDK_CREDENTIALS_TOKEN_REFRESH_SCOPE_MISMATCH:
    'JS_SDK_CREDENTIALS_TOKEN_REFRESH_SCOPE_MISMATCH',
};
